module.exports = __webpack_public_path__ + "static/media/Salads.d45c3bd6.svg";